import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../_redux/invitedUsersActions';
import * as columnFormatters from './ColumnFormatters';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useInvitedUsersUIContext} from '../InvitedUsersUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";


export function InvitedUsersTable() {
  const intl = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'invitedFriend',
      Header: intl.formatMessage({
        id: 'invited-users-column-invitedFriend', defaultMessage: 'Invited friend'
      })
    },
    {
      accessor: 'invitingUser',
      Header: intl.formatMessage({
        id: 'invited-users-column-invitingUser', defaultMessage: 'Inviting user'
      })
    },
    {
      accessor: 'lastCompletedStep',
      Header: intl.formatMessage({
        id: 'invited-users-column-lastCompletedRegStep', defaultMessage: 'Last completed reg step'
      })
    },
    {
      accessor: 'invitedFriendAgentId',
      Header: intl.formatMessage({
        id: 'invited-users-column-agentId', defaultMessage: 'Agent ID'
      })
    },
    {
      accessor: 'invitedFriendCreatedAt',
      Header: intl.formatMessage({
        id: 'invited-users-column-createdAt', defaultMessage: 'Created at'
      })
    },
    {
      accessor: 'invoices',
      Header: intl.formatMessage({
        id: 'invited-users-column-invoices', defaultMessage: 'Invoices'
      })
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item, index) => {
      const friendAgentID = Boolean(item.invitedFriend.agentId)
        ? item.invitedFriend.agentId
        : '';

      return {
        invitedFriend: columnFormatters.InvitedFriendColumnFormatter(item.invitedFriend),
        invitingUser: columnFormatters.InvitingUserColumnFormatter(item.invitingUser),
        lastCompletedStep: commonColumnFormatters.LastCompletedStepColumnFormatter(item.lastCompletedStep),
        invitedFriendAgentId: commonColumnFormatters.BoldColumnFormatter(friendAgentID),
        invitedFriendCreatedAt: commonColumnFormatters.DateColumnFormatter(item.invitedFriend.createdAt),
        invoices: columnFormatters.InvoicesColumnFormatter(item.invoices),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: "invitedUsers",
    UIContext: useInvitedUsersUIContext(),
    getNewEntities: actions.getInvitedUsers,
    getNextEntities: actions.getNextInvitedUsers,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
    />
  );
}
